import { tableBaseConfig, searchBaseConfig } from '@otp/utils/baseDataConfig';
export default {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '来源系统',
                value: 'sourceSystem',
                type: 'select',
                unfold: true,
                filterable: true,
                optionNum: 'SOURCE_SYSTEM',
                options: [],
                span: 4
            },
            {
                name: '订单类型',
                value: 'orderType',
                type: 'select',
                unfold: true,
                filterable: true,
                optionNum: 'ORDER_TYPE',
                options: [],
                span: 4
            },
           { ...searchBaseConfig.customer,
            'advanceConfig': [
                { 'prop': 'pmCodeOrNameCn', 'value': '客户编码或名称' }
            ],
            'advancePlaceholder': "支持模糊查询",
           },
            // 服务平台
           { ...searchBaseConfig.site,
                'advanceConfig': [
                    { 'prop': 'escoCompanyNoOrNameCn', 'value': '服务平台编码或名称' },
                ],
                'advancePlaceholder': "支持模糊查询",
                'tableConfig': [
                    { 'prop': 'siteCode', 'value': '服务平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称', 'displayName': true },
                    { 'prop': 'companyCode', 'value': '分公司编码' },
                    { 'prop': 'companyName', 'value': '分公司名称' }
                ],
                'advanceUrl': '/esCompany/searchSiteV2?escoCompanyType=P',
            },
            {
                name: '是否启用',
                value: 'enableFlag',
                unfold: true,
                type: 'select',
                span: 2,
                options: [
                    { label: '启用', value: 1 },
                    { label: '停用', value: 0 }
                ]
            }

        ],
        unfoldState: false
    },
    table: {
        tableCut: true,
        clickModify: true,
        selectBtn: true,
        leftWidth: 100,
        height: 400,
        leftOperation: true,
        statesY: '启用',
        statesN: '停用',
        columns: [
            {
                label: '来源系统',
                prop: 'sourceSystem',
                require: true,
                mustFill: true,
                width: 120,
                type: 'select',
                optionNum: 'SOURCE_SYSTEM',
                options: [],
                sort: true
            },
            Object.assign(tableBaseConfig.customer, {
                mustFill: true,
                'advanceConfig': [
                    { 'prop': 'pmCodeOrNameCn', 'value': '客户编码或名称' }
                ],
                'advancePlaceholder': "支持模糊查询",
             }),
            {
                label: '订单类型',
                prop: 'orderType',
                require: true,
                mustFill: true,
                width: 120,
                type: 'select',
                optionNum: 'ORDER_TYPE',
                options: [],
                sort: true
            },
            Object.assign(tableBaseConfig.site, {
                mustFill: true,
                'advanceConfig': [
                    { 'prop': 'escoCompanyNoOrNameCn', 'value': '服务平台编码或名称' },
                ],
                'advancePlaceholder': "支持模糊查询",
                'tableConfig': [
                    { 'prop': 'siteCode', 'value': '服务平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称', 'displayName': true },
                    { 'prop': 'companyCode', 'value': '分公司编码' },
                    { 'prop': 'companyName', 'value': '分公司名称' }
                ],
                'advanceUrl': '/esCompany/searchSiteV2?escoCompanyType=P',
            }),
            // {
            //     label: '收货地址',
            //     mustFill: true,
            //     require: true,
            //     prop: 'address',
            //     labelCn: 'addressCn',
            //     type: 'addressCascader',
            //     config: {
            //         checkStrictly: true
            //     },
            //     minLayers: 4,
            //     width: 240
            // },
            {
                label: '客户详细地址',
                prop: 'detailAddr',
                require: true,
                mustFill: true,
                sort: true,
                width: 280,
                type: 'input'
            },
            {
                label: '是否启用',
                prop: 'enableFlag',
                activeValue: 1,
                inactiveValue: 0,
                defaultValue: 1,
                width: 90,
                type: 'switch',
                require: true
            },

            {
                label: '修改人',
                prop: 'updateUserNameAndCode',
                width: 140,
                sort: true
            },

            {
                label: '修改时间',
                prop: 'updateTime',
                width: 160,
                sort: true
            },
            {
                label: '创建人',
                prop: 'createUserNameAndCode',
                width: 140,
                sort: true
            },

            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit',
                ifHas: '06380006'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    },
    import: {
        ImportConfig: {
            action: `${process.env.VUE_APP_API_URL || ''}/api-otp/order/excelImport`,
            multiple: true,
            accept: 'xlsx/text',
            showFileList: true,
            fileType: '只能上传Excel文件',
            manualUpload: false
        },
        ImportContent: [
            {
                fileName: '商超地址导入模板.xlsx',
                fileSize: '9KB',
                dictName: 'IMPORT_OTP_SUPERMARK_RULE',
                downLoadInfo: {
                    url: ''
                }
            }
        ],
        templateTypes: [
            {
                fileList: [],
                inOutType: 'SC',
                tips: '商超地址导入'
            }
        ]
    }
};
